import type { IFetchRequest, IProgressPromise } from '@monofe/util';

export enum IServiceWorkerStatus {
    Off = 0 /* Unset */,
    Idle = 1 /* Initializing */,
    Starting = 2 /* Registering for interception */,
    Ready = 3 /* Initialized, but not intercepting requests */,
    Running = 4 /* Running & intercepting requests */,
    Stopped = 5,
}

export type IServiceWorkerCallback = (worker: IServiceWorkerClient) => void;

export interface IServiceWorkerClient {
    status: IServiceWorkerStatus;
    start: () => void;
    stop: () => void;

    subscribeStatusChange: (callback: IServiceWorkerCallback) => void;
    unsubscribeStatusChange: (callback: IServiceWorkerCallback) => void;

    isInterceptingNetworkRequests: () => boolean;

    addCacheFirst: (matcher: RegExp, maxAge: number, maxEntries: number, cacheName: string) => void;
    addOAuthTokenCache: (pathSuffix: string) => void;
    addZipPathFetchResponder: (zipPath: string, relativeRespondPath: string) => void;
    addHeader: (matcher: RegExp, headerKey: string, headerVal: string, expiration: Date) => void;

    isRequestCached: (request: IFetchRequest, cacheName?: string) => Promise<boolean>;
    addRequestsToCache: (
        requests: IFetchRequest[],
        options?: {
            cacheName?: string /* When missing attempt to find a match based on installed MessageResponders */;
        },
    ) => IProgressPromise<void>;
}
